export default `
mutation archiveClient($id: ID!, $serviceProviderId: ID!) {
  archiveClient(id: $id, serviceProviderId: $serviceProviderId) {
    id
    serviceProviderId
    updatedAt
    propertyIds
    firstName
    lastName
    email
    isArchived
    isDeleted
  }
}
`;
